import {Component, Input, OnChanges} from '@angular/core';
import {Categories} from '../../model/resource-model';

@Component({
  selector: 'app-categories-chips',
  templateUrl: './categories-chips.component.html',
  styleUrls: ['./categories-chips.component.css']
})
export class CategoriesChipsComponent {
  @Input() categories: Categories[] = [];
  
}
